import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'av-rail',
  standalone: true,
  host: {
    '[class.av-rail--offset]': "offset() !== '0'",
  },
  templateUrl: './av-rail.component.html',
  styleUrl: './av-rail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvRailComponent {
  readonly active = input<boolean>(false);
  /** CSS length the track is pushed down by, so a table rail sits under its header */
  readonly offset = input<string>('0');
}
